import {
  ASSINATURA,
  ASSINATURA_COM_SELO,
  LOGOTIPO,
  marca,
  SIMBOLO,
  simboloNoSelo,
  transformDoSimbolo,
} from '@entregas/theme';

// Marca desenhada em SVG a partir de @entregas/theme (o nome já vem em contorno: não depende de fonte).
// Opção A: o cubo vai dentro de um selo com o par da aba ativa (claro: selo tinta e cubo limão; escuro: selo limão e
// cubo tinta) e o nome é neutro. Os padrões seguem o tema; quem está num fundo fixo (topo da landing) passa as cores.

function DesenhoSimbolo({ v, cor }: { v: typeof SIMBOLO; cor: string }) {
  return (
    <>
      {v.barras && (
        <path
          d={v.barras}
          fill="none"
          stroke={cor}
          strokeWidth={v.espessuraBarras}
          strokeLinecap="round"
        />
      )}
      {v.faces.map((d) => (
        <path
          key={d}
          d={d}
          fill={cor}
          stroke={cor}
          strokeWidth={v.raio * 2}
          strokeLinejoin="round"
        />
      ))}
    </>
  );
}

interface PropsSimbolo {
  /** Altura em px. */
  tamanho?: number;
  cor?: string;
  className?: string;
}

/** Símbolo sozinho, sem selo. */
export function Simbolo({ tamanho = 24, cor = 'var(--cor-marca-texto)', className }: PropsSimbolo) {
  const v = SIMBOLO;
  return (
    <svg
      width={(v.largura * tamanho) / v.altura}
      height={tamanho}
      viewBox={v.viewBox}
      className={className}
      aria-hidden="true"
    >
      <DesenhoSimbolo v={v} cor={cor} />
    </svg>
  );
}

interface PropsLogo {
  /** Altura em px: com selo, é o lado dele. */
  altura?: number;
  /**
   * Logo sem selo: só abaixo de 18 px (rodapé do rastreio) e na impressão (cupom). O cubo vai em
   * `var(--cor-marca-texto)` e o nome herda a cor do texto em volta.
   */
  solto?: boolean;
  corSelo?: string;
  corSimbolo?: string;
  corNome?: string;
  className?: string;
}

export function Logo({
  altura = 38,
  solto = false,
  corSelo,
  corSimbolo,
  corNome,
  className,
}: PropsLogo) {
  const a = solto ? ASSINATURA : ASSINATURA_COM_SELO;
  const selo = solto ? null : simboloNoSelo(ASSINATURA_COM_SELO.selo);
  return (
    <svg
      width={(a.largura * altura) / a.altura}
      height={altura}
      viewBox={`0 0 ${a.largura} ${a.altura}`}
      className={className}
      role="img"
      aria-label={marca.nome}
    >
      {selo ? (
        <>
          <rect
            width={ASSINATURA_COM_SELO.selo.lado}
            height={ASSINATURA_COM_SELO.selo.lado}
            rx={selo.raio}
            fill={corSelo ?? 'var(--cor-marca)'}
          />
          <g transform={selo.transform}>
            <DesenhoSimbolo v={SIMBOLO} cor={corSimbolo ?? 'var(--cor-texto-sobre-marca)'} />
          </g>
        </>
      ) : (
        <g transform={transformDoSimbolo(SIMBOLO, ASSINATURA.simbolo)}>
          <DesenhoSimbolo v={SIMBOLO} cor={corSimbolo ?? 'var(--cor-marca-texto)'} />
        </g>
      )}
      <path
        transform={`translate(${a.logotipo.x} ${a.logotipo.y})`}
        d={LOGOTIPO.d}
        fill={corNome ?? (solto ? 'currentColor' : 'var(--cor-texto)')}
      />
    </svg>
  );
}
